import React from "react";
import '../../Styles/Sass/Listings/Filter/filter.sass';
// import { makeStyles } from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

// const useStyles = makeStyles({
//   root: {
//     width: 300,
//   },
// });

function valuetext(value) {
  return `${value}`;
}

function Filter(props) {
  const [currentRate, setCurrentRate] = React.useState(150);

  const setBudget = (e) => {
    e.preventDefault();
    props.setFilter('rate', e.target.rate.value);
  }

  return (
    <div className="filter-BG">
      <div className="filterOptions">
        <div className="filterSearch" >
          <h3 className='filterSearch__title'>Search For:</h3>
          <input className="search"
            type="text"
            placeholder="Search by Keyword..."
          />
        </div>
        <div className="filterSearch" >
          <h3 className='filterSearch__title'>Area of Work:</h3>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='home'
              defaultChecked={props.jobFilter.areaOfWork.includes('home')}
              onChange={() => props.setFilter('areaOfWork', 'home')}
            />
            <label htmlFor="home"> Home</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='commercial'
              defaultChecked={props.jobFilter.areaOfWork.includes('commercial')}
              onChange={() => props.setFilter('areaOfWork', 'commercial')}
            />
            <label htmlFor="commercial"> Commercial</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='restaurant'
              defaultChecked={props.jobFilter.areaOfWork.includes('restaurant')}
              onChange={() => props.setFilter('areaOfWork', 'restaurant')}
            />
            <label htmlFor="restaurant"> Restaurant</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='industrial'
              defaultChecked={props.jobFilter.areaOfWork.includes('industrial')}
              onChange={() => props.setFilter('areaOfWork', 'industrial')}
            />
            <label htmlFor="industrial"> Industrial</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='project'
              defaultChecked={props.jobFilter.areaOfWork.includes('project')}
              onChange={() => props.setFilter('areaOfWork', 'project')}
            />
            <label htmlFor="project"> Project</label>  
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='events'
              defaultChecked={props.jobFilter.areaOfWork.includes('events')}
              onChange={() => props.setFilter('areaOfWork', 'events')}
            />
            <label htmlFor="events"> Events</label>    
          </div>
        </div>
        <div className="filterSearch" >
          <h3 className='filterSearch__title'>Services</h3>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='offices'
              defaultChecked={props.jobFilter.requiredServices.includes('offices')}
              onChange={() => props.setFilter('requiredServices', 'offices')}
            />
            <label htmlFor="offices"> Offices</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='washrooms'
              defaultChecked={props.jobFilter.requiredServices.includes('washrooms')}
              onChange={() => props.setFilter('requiredServices', 'washrooms')}
            />
            <label htmlFor="washrooms"> Washrooms</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='kitchen'
              defaultChecked={props.jobFilter.requiredServices.includes('kitchen')}
              onChange={() => props.setFilter('requiredServices', 'kitchen')}
            />
            <label htmlFor="kitchen"> Kitchen</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='specialty'
              defaultChecked={props.jobFilter.requiredServices.includes('specialty')}
              onChange={() => props.setFilter('requiredServices', 'specialty')}
            />
            <label htmlFor="specialty"> Specialty</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='carpet'
              defaultChecked={props.jobFilter.requiredServices.includes('carpet')}
              onChange={() => props.setFilter('requiredServices', 'carpet')}
            />
            <label htmlFor="carpet"> Carpet</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='floorCare'
              defaultChecked={props.jobFilter.requiredServices.includes('floorCare')}
              onChange={() => props.setFilter('requiredServices', 'floorCare')}
            />
            <label htmlFor="floorCare"> Floor Care</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='window'
              defaultChecked={props.jobFilter.requiredServices.includes('window')}
              onChange={() => props.setFilter('requiredServices', 'window')}
            />
            <label htmlFor="window"> Window</label>
          </div>
        </div>
        <div className="filterSearch" >
            <h3 className='filterSearch__title'>Job Availablity:</h3>
            <div className='filterSearch__inputBox'>
              <input
                className='filterSearch__checkBox'
                type="checkbox"
                name='mornings'
                defaultChecked={props.jobFilter.availability.includes('mornings')}
                onChange={() => props.setFilter('availability', 'mornings')}
              />
              <label htmlFor="mornings"> Mornings</label>
            </div>
            <div className='filterSearch__inputBox'>
              <input
                className='filterSearch__checkBox'
                type="checkbox"
                name='days'
                defaultChecked={props.jobFilter.availability.includes('days')}
                onChange={() => props.setFilter('availability', 'days')}
              />
              <label htmlFor="days"> Days</label>
            </div>
            <div className='filterSearch__inputBox'>
              <input
                className='filterSearch__checkBox'
                type="checkbox"
                name='evenings'
                defaultChecked={props.jobFilter.availability.includes('evenings')}
                onChange={() => props.setFilter('availability', 'evenings')}
              />
              <label htmlFor="evenings"> Evenings</label>
            </div>
            <div className='filterSearch__inputBox'>
              <input
                className='filterSearch__checkBox'
                type="checkbox"
                name='nights'
                defaultChecked={props.jobFilter.availability.includes('nights')}
                onChange={() => props.setFilter('availability', 'nights')}
              />
              <label htmlFor="nights"> Nights</label>
            </div>
            <div className='filterSearch__inputBox'>
              <input
                className='filterSearch__checkBox'
                type="checkbox"
                name='weekends'
                defaultChecked={props.jobFilter.availability.includes('weekends')}
                onChange={() => props.setFilter('availability', 'weekends')}
              />
              <label htmlFor="weekends"> Weekends</label>
            </div>
            <div className='filterSearch__inputBox'>
              <input
                className='filterSearch__checkBox'
                type="checkbox"
                name='smallProjects'
                defaultChecked={props.jobFilter.availability.includes('smallProjects')}
                onChange={() => props.setFilter('availability', 'smallProjects')}
              />
              <label htmlFor="smallProjects"> Small Projects</label>
            </div>
        </div>
        <div className="filterSearch" >
          <h3 className='filterSearch__title'>Cleaners Required:</h3>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="radio"
              name='numberOfWorkers'
              defaultChecked={props.jobFilter.numberOfWorkers === 0}
              onChange={() => props.setFilter('numberOfWorkers', 0)}
            />
            <label htmlFor="one"> All</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="radio"
              name='numberOfWorkers'
              defaultChecked={props.jobFilter.numberOfWorkers === 1}
              onChange={() => props.setFilter('numberOfWorkers', 1)}
            />
            <label htmlFor="one"> 1 Person</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="radio"
              name='numberOfWorkers'
              defaultChecked={props.jobFilter.numberOfWorkers === 2}
              onChange={() => props.setFilter('numberOfWorkers', 2)}
            />
            <label htmlFor="two"> 2 People</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="radio"
              name='numberOfWorkers'
              defaultChecked={props.jobFilter.numberOfWorkers === 3}
              onChange={() => props.setFilter('numberOfWorkers', 3)}
            />
            <label htmlFor="three"> 3 People</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="radio"
              name='numberOfWorkers'
              defaultChecked={props.jobFilter.numberOfWorkers === 4}
              onChange={() => props.setFilter('numberOfWorkers', 4)}
            />
            <label htmlFor="four"> 4 People</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="radio"
              name='numberOfWorkers'
              defaultChecked={props.jobFilter.numberOfWorkers === 5}
              onChange={() => props.setFilter('numberOfWorkers', 5)}
            />
            <label htmlFor="five"> 5 or More People</label>
          </div>
        </div>
        <div className="filterSearch" >
          <h3 className='filterSearch__title'>Other: </h3>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='supplies'
              defaultChecked={props.jobFilter.supplies}
              onChange={() => props.setFilter('supplies')}
            />
            <label htmlFor="supplies"> Employer Provides Supplies</label>
          </div>
          <div className='filterSearch__inputBox'>
            <input
              className='filterSearch__checkBox'
              type="checkbox"
              name='equipment'
              defaultChecked={props.jobFilter.equipment}
              onChange={() => props.setFilter('equipment')}
            />
            <label htmlFor="equipment"> Employer Provides Equipment</label>
          </div>
        </div>

        <div className="filterSearch" >
          <h3 className='filterSearch__title'>
            Budget: {
              currentRate > 149 ?
                '+$150 per hour' :
                `$${currentRate} per hour`
            }
          </h3>
          <form
            className='budgetForm'
            onSubmit={setBudget}
          >
            <Slider
              name='rate'
              defaultValue={150}
              getAriaValueText={valuetext}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={16}
              max={150}
              onChange={(e) => setCurrentRate(e.target.ariaValueNow)}
            />
            <button
              buttonType='submit'
              className='blueButton setBudgetButton'
            >
              Set Budget
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Filter;